import { render, staticRenderFns } from "./WarehouseListView.vue?vue&type=template&id=2168ce10"
import script from "./WarehouseListView.vue?vue&type=script&lang=js"
export * from "./WarehouseListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports